module.exports = __webpack_public_path__ + "img/motion.0487a013.png";